import type { FormElement, RegisterNumberInputProperties } from '../../model/form.types';
import type { FieldDefinition } from '../../model/types';
import { singleColumn, stringShapeIssue, validateFormattedText, valueAsText } from './shared';

type RegisterNumberInputElement = FormElement & { properties: RegisterNumberInputProperties };

export const INVALID_REGISTER_NUMBER_MESSAGE = 'Matrícula deve ter 6 dígitos.';

const REGISTER_NUMBER_PATTERN = /^\d{6}$/;

// Only the shape is checked here: whether the number belongs to a collaborator needs a lookup,
// which the pure engine cannot do and the server does when the answer is saved.
function isRegisterNumber(text: string): boolean {
  return REGISTER_NUMBER_PATTERN.test(text);
}

export const registerNumberInputDefinition: FieldDefinition<RegisterNumberInputElement> = {
  kind: 'field',
  type: 'REGISTER_NUMBER_INPUT',
  emptyValue: () => '',
  control: (element) => ({ kind: 'text', placeholder: element.properties.placeholder }),
  shapeIssue: stringShapeIssue,
  validate: (element, value) =>
    validateFormattedText(element, value, isRegisterNumber, INVALID_REGISTER_NUMBER_MESSAGE),
  columns: singleColumn,
  cells: (_element, value) => [valueAsText(value)],
  triggerMatches: () => false,
};
